import React from 'react'
import PageList from '../../../components/PageListAPI'
import { getPlanListAPI, delPlanByIdAPI } from '../../../api/tariff.api'
import { useHistory, useLocation } from 'react-router-dom'

export default function TariffList() {
  const location = useLocation()
  const history = useHistory()
  return (
    <div className='App-paper'>
      <PageList
        title='Тарифы'
        name='tariff-list'
        columns={[{ id: 'name', name: 'Название' }]}
        createItem={true}
        deleteItem={true}
        loadAPI={{
          request: getPlanListAPI,
        }}
        deleteAPI={delPlanByIdAPI}
        location={location}
        history={history}
      />
    </div>
  )
}